<template>
  <ListPanel :portal="portal" :layout-categories="layoutCategories"/>
</template>

<script>
import ListPanel from '../../../../../../../components/Administration/ContentLayouts/Panels/List'

export default {
  components: {ListPanel},

  props: {
    portal: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  }
}
</script>
